<a [href]="getBlogDetailLink()" class="no-decor" target="_blank">
  <h2 [class]="'overflow-hidden margin-0 sparro-grey-900 font-bolder ' + 
    (cardWidth<=541 ? 'blog-title-md' : 'blog-title')">
    <ng-container *ngIf="blog.title">
      {{ blog.title }}
    </ng-container>
    <ng-container *ngIf="!blog.title">{{ defaultTitle }}</ng-container>
  </h2>
</a>
